import "./style.scss";
import $ from "jquery";
import 'slick-carousel';
import "slick-carousel/slick/slick.scss";

var initializeBlock = function () {
    if ($('.taxonomies-cards__slider').length) {
        $(".taxonomies-cards__slider").each(function () {
            const totalSlides = $(this).find('.clanki-taxonomy-card').length;
            $(this).not(".slick-initialized").slick({
                slidesToShow: totalSlides >= 5 ? 5 : totalSlides,
                infinite: false,
                fade: false,
                dots: true,
                arrows: true,
                nextArrow: '<div class="ow-slick-arrow ow-slick-arrow--next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M11.2929 4.29289C11.6834 3.90237 12.3166 3.90237 12.7071 4.29289L19.7071 11.2929C20.0976 11.6834 20.0976 12.3166 19.7071 12.7071L12.7071 19.7071C12.3166 20.0976 11.6834 20.0976 11.2929 19.7071C10.9024 19.3166 10.9024 18.6834 11.2929 18.2929L16.5858 13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H16.5858L11.2929 5.70711C10.9024 5.31658 10.9024 4.68342 11.2929 4.29289Z" fill="#100F0E"/></svg></div>',
                prevArrow: '<div class="ow-slick-arrow ow-slick-arrow--prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12.7071 19.7071C12.3166 20.0976 11.6834 20.0976 11.2929 19.7071L4.29289 12.7071C3.90237 12.3166 3.90237 11.6834 4.29289 11.2929L11.2929 4.29289C11.6834 3.90237 12.3166 3.90237 12.7071 4.29289C13.0976 4.68342 13.0976 5.31658 12.7071 5.70711L7.41421 11L19 11C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13L7.41421 13L12.7071 18.2929C13.0976 18.6834 13.0976 19.3166 12.7071 19.7071Z" fill="#100F0E"/></svg></div>',
                draggable: true,
                appendDots: $(this).parent().find('.taxonomies-cards__dots'),
                appendArrows: $(this).parent().find('.taxonomies-cards__arrows'),
                responsive: [
                    {
                        breakpoint: 990,
                        settings: {
                            slidesToShow: totalSlides >= 4 ? 4 : totalSlides,
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: totalSlides >= 3 ? 3 : totalSlides,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: totalSlides >= 2 ? 2 : totalSlides,
                        }
                    }
                ]
            });
        });
    }
}

initializeBlock();

if (window.acf) {
    window.acf.addAction('render_block_preview/type=ow/taxonomy-terms-slider', initializeBlock);
}